module.exports = __webpack_public_path__ + "static/media/1.6.0d9800ea.png";